<template>
  <window :title="data.ov.name" class="sett-win" :tv="tv" @close="on_close">
    <div class="sett-win-list">
      <div v-for="k in settlist" :key="k" style="width: 100%;">
        <!-- If it is the periodList array, render each period and its color picker -->
        <div v-if="k === 'periodList' && Array.isArray(localSettings[k])" style="width: 100%;">
          <div v-for="(item, index) in localSettings[k]" :key="index" class="sett-win-item p-mb-2">
            <label style="min-width: 80px;">Period {{ index + 1 }}</label>
            <std-input :value="item.period" @input="update_period_list_item(index, 'period', $event)" type="number" />
            <std-input :value="item.color" @input="update_period_list_item(index, 'color', $event)" type="color" />
          </div>
        </div>
        <!-- Default fallback for other properties -->
        <div v-else class="sett-win-item">
          <label>{{ s2d(k) }}</label>
          <std-input :value="localSettings[k]" @input="update_sett(k, $event)" :type="getType(k)" :step="getStep(k)" />
        </div>
      </div>
      <div v-for="k in styleSettings" :key="k">
        <div v-if="Array.isArray(localSettings[k])">
          <div v-for="(colorVal, index) in localSettings[k]" :key="index" class="sett-win-item">
            <!-- Renders 'Colors 1', 'Colors 2', etc. -->
            <label>
              {{ index === 0 ? 'Color 1' : (index === 1 ? 'Color 2' : s2d(k) + ' ' + (index + 1)) }}
            </label>
            <std-input :value="colorVal" @input="update_sett_array(k, index, $event)" type="color" />
          </div>
        </div>
        <div v-else class="sett-win-item">
          <label>{{ s2d(k).replace(' Enable', '') }}</label>
          <std-input :value="localSettings[k]" @input="update_sett(k, $event)" :type="getType(k)" :step="getStep(k)" />
        </div>
      </div>

      <div v-for="(k, i) in groupSettings" :key="i" class="sett-win-item p-d-flex p-ai-center p-jc-between">
        <div>
          <label>{{ s2d(k).replace(' Group', '') }}</label>
        </div>
        <div class="p-d-flex p-ai-center">
          <div v-for="(keys, index) in Object.keys(localSettings[k] || {})" :key="index">
            <std-input :value="localSettings[k][keys]" @input="update_sett_grp(k, keys, $event)" :type="getType(keys)"
              :step="getStep(keys)" :classGrp="true" />
          </div>
        </div>
      </div>
      <span v-if="!settlist.length && !styleSettings.length" class="sett-win-empty">
        <i>No settings</i>
      </span>
    </div>

    <!-- Footer actions with Save and Cancel buttons -->
    <div class="sett-win-footer">
      <!-- <button type="button" class="sett-btn sett-btn-cancel" @click="on_close">
        Cancel
      </button> -->
      <button type="button" class="sett-btn sett-btn-save" :disabled="isSaving" @click="on_save">
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </window>
</template>
<script>
import Window from '../shared/Window.vue'
import StdInput from '../shared/StdInput.vue'
import Utils from './utils.js'

export default {
  name: 'SettingsWin',
  components: { Window, StdInput },
  props: ['id', 'main', 'dc', 'tv', 'data'],
  data() {
    return {
      localSettings: {},
      isSaving: false
    }
  },
  created() {
    this.initLocalSettings()
  },
  computed: {
    sett() {
      return this.$props.data.ov.settings
    },
    settlist() {
      const ovName = this.data?.ov?.name?.toLowerCase();
      const ovType = this.data?.ov?.type?.toLowerCase();
      
      if (ovName === 'ichi' || ovType === 'ichi') {
        return ['CP', 'BP', 'LSP', 'DIZ']
      }
      return Object.keys(this.localSettings).filter(
        x => x[0] !== '$' && this.sett.$props && this.sett.$props.includes(x)
      )
    },
    styleSettings() {
      const ovName = (this.$props.data.ov.name || '').toLowerCase();
      const ovType = (this.$props.data.ov.type || '').toLowerCase();
      return Object.keys(this.localSettings).filter(
        x => x[0] !== '$' && 
             x.match(/(color|width|enable)/i) != null && 
             !((ovName === 'ichi' || ovType === 'ichi') && (x === 'color' || x === 'baseLineWidth' || x === 'laggingLineWidth'))
      )
    },
    groupSettings() {
      let dataList = Object.keys(this.localSettings).filter(
        x => x[0] !== '$' && x.match(/(group)/i) != null
      )
      return dataList
    }
  },
  methods: {
    initLocalSettings() {
      this.localSettings = JSON.parse(JSON.stringify(this.$props.data.ov.settings || {}))
    },
    getType(field) {
      if (field.match(/color/i) != null) return 'color'
      if (field.match(/(period|length|width)/i) != null) return 'number'
      if (field.match(/(enable)/i) != null) return 'bool'
      return 'number'
    },
    getStep(field) {
      return 1
    },
    s2d(str) {
      return Utils.sett2desc(str)
    },
    on_close() {
      this.$props.main.remove_widget(this.$props.id)
    },
    update_sett_grp(grp, k, val) {
      let valN = parseFloat(val)
      if (valN !== valN) valN = val
      if (!this.localSettings[grp]) {
        this.$set(this.localSettings, grp, {})
      }
      this.$set(this.localSettings[grp], k, valN)
    },
    update_sett_array(k, index, val) {
      let arr = [...(this.localSettings[k] || [])]
      arr[index] = val
      this.$set(this.localSettings, k, arr)
    },
    getColorLabel(key, index, name) {
      if (name.includes('TSI') && key === 'colors') {
        return index === 0 ? 'TSI' : 'Signal'
      }
      if (name.includes('DMI') && key === 'colors') {
        if (index === 0) return 'ADX'
        if (index === 1) return '+DI'
        if (index === 2) return '-DI'
      }
      return `${this.s2d(key)} ${index + 1}`
    },
    update_sett(k, val) {
      let valN = parseFloat(val)
      if (valN !== valN) valN = val
      this.$set(this.localSettings, k, valN)
    },
    update_sett_arr(k, index, val) {
      let colors = [...(this.localSettings[k] || [])]
      colors[index] = val
      this.$set(this.localSettings, k, colors)
    },
    update_period_list_item(index, field, val) {
      let list = [...(this.localSettings.periodList || [])]
      let valN = parseFloat(val)
      if (valN !== valN) valN = val
      list[index] = {
        ...list[index],
        [field]: valN
      }
      this.$set(this.localSettings, 'periodList', list)
    },
    async on_save() {
      if (this.isSaving) return
      this.isSaving = true
      try {
        let dcid = this.$props.data.ov.id
        const ovName = (this.$props.data.ov?.name || '').toLowerCase()
        const isPartOfIchi = this.$props.data.ov?.settings?.isPartOfIchi || ovName.includes('base line') || ovName.includes('lagging')
        
        if (this.$props.data.ov && this.$props.data.ov.settings) {
          this.$props.data.ov.settings = { ...this.$props.data.ov.settings, ...this.localSettings }
        }

        // 1. Apply draft settings to the chart overlay
        this.$props.dc.merge(`${dcid}.settings`, this.localSettings)

        // If this is a child overlay of Ichi (Base Lines or Lagging Span), sync with parent Ichi overlay in DataCube
        if (isPartOfIchi) {
          const onchart = this.$props.dc.data?.onchart || []
          const ichiOverlay = onchart.find(o => (o.name || '').toLowerCase() === 'ichi' || (o.type || '').toLowerCase() === 'ichi')
          if (ichiOverlay) {
            if (ovName.includes('base line') || ovName.includes('base lines')) {
              const ichiUpdates = { baseLineWidth: Number(this.localSettings.lineWidth) }
              if (this.localSettings.colors && Array.isArray(this.localSettings.colors)) {
                if (this.localSettings.colors[0]) ichiUpdates.conversionColor = this.localSettings.colors[0]
                if (this.localSettings.colors[1]) ichiUpdates.baseColor = this.localSettings.colors[1]
              }
              if (ichiOverlay.settings) {
                Object.assign(ichiOverlay.settings, ichiUpdates)
              }
              this.$props.dc.merge(`${ichiOverlay.id}.settings`, ichiUpdates)
            } else if (ovName.includes('lagging')) {
              const ichiUpdates = { laggingLineWidth: Number(this.localSettings.lineWidth) }
              if (this.localSettings.color) ichiUpdates.laggingColor = this.localSettings.color
              if (ichiOverlay.settings) {
                Object.assign(ichiOverlay.settings, ichiUpdates)
              }
              this.$props.dc.merge(`${ichiOverlay.id}.settings`, ichiUpdates)
            }
          }
        }

        // Reset/re-render the chart so recalculation occurs (e.g. for period changes)
        if (this.tv && typeof this.tv.resetChart === 'function') {
          this.tv.resetChart()
        }

        // 2. Persist globally into store userData and backend database
        await this.$store.dispatch('saveOverlaySettings', {
          ov: this.$props.data.ov,
          newSettings: this.localSettings,
          dataIndex: this.$props.data.dataIndex
        })

        // 3. Close the settings window
        this.on_close()
      } catch (e) {
        console.error("Error saving indicator settings:", e)
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
<style scoped>
.tvjs-x-window.sett-win {
  padding-bottom: 12px;
}

.sett-win-list {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.sett-win-item {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-content: center;
  align-items: center;
}

.sett-win-item label {
  min-width: 100px;
}

.sett-win-empty {
  opacity: 0.5;
}

.sett-win-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 10px;
  border-top: 1px solid rgba(128, 128, 128, 0.2);
}

.sett-btn {
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.sett-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sett-btn-cancel {
  background-color: transparent;
  color: #888;
  border-color: rgba(128, 128, 128, 0.3);
}

.sett-btn-cancel:hover {
  background-color: rgba(128, 128, 128, 0.1);
  color: #bbb;
}

.sett-btn-save {
  background-color: #2780e3;
  color: #fff;
}

.sett-btn-save:hover:not(:disabled) {
  background-color: #1967be;
}
</style>
